import { defineStyle } from '@chakra-ui/react/styled-system';

const shimmerMask =
  'linear-gradient(to left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.63) 35%, rgb(0, 0, 0) 48%, rgba(0, 0, 0, 0.57) 55%, rgba(0, 0, 0, 0) 100%)';

// A soft-masked highlight band sweeping left→right, painted as an `::after` overlay. Shared by the
// single-shape Skeleton recipe and BitkitSkeletonGroup so one sweep can span a whole group of shapes.
export const skeletonShimmerAfter = defineStyle({
  content: '""',
  position: 'absolute',
  inset: 0,
  backgroundColor: 'utilities/skeleton-highlight',
  maskImage: shimmerMask,
  WebkitMaskImage: shimmerMask,
  animation: 'skeleton-shimmer var(--duration, 1.5s) linear infinite',
  pointerEvents: 'none',
});
